/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function EnvironmentIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<>
                    <path fillRule="evenodd" clipRule="evenodd" d="M6 5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm.75 2a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75h2.5a.75.75 0 0 0 .75-.75v-2.5A.75.75 0 0 0 9.25 7z"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M6 16a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm.75 2a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75h2.5a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75z"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M6 27a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm.75 2a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75h2.5a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75z"/>
                </>}
        </IconWrapper>);
}
